// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={591.978}
      height={153.249}
      viewBox="0 0 591.978 153.249"
      {...props}
    >
      <defs>
        <clipPath id="AllianzIcon__a">
          <path d="M1457.1 761.7h87.3v-22.6h-87.3v22.6z" />
        </clipPath>
      </defs>
      <g fill="#004a93">
        <path
          d="M53.57 82.664h-21.7l11.528-37.499 10.171 37.499zm-31.871 37.905 6.78-22.852h27.803l6.78 22.852h23.056L61.706 33.841c-1.356-5.696-4.068-7.527-10.171-7.527H17.63v7.798h2.713c4.068 0 6.103 1.289 6.103 4.408 0 1.966 0 3.255-2.035 7.934L0 120.569"
          fillRule="evenodd"
        />
        <path d="M115.276 120.57V33.23c0-4.542-2.713-6.916-7.46-6.916h-21.02v7.798h1.356c4.069 0 6.103 1.696 6.103 5.357v81.1M153.249 120.57V33.23c0-4.542-2.712-6.916-7.46-6.916h-21.02v7.798h1.356c4.069 0 6.103 1.696 6.103 5.357v81.1" />
        <path
          d="M191.9 34.655c0-6.239-4.746-9.9-12.205-9.9-8.138 0-12.206 3.661-12.206 9.9 0 6.374 4.068 10.103 12.206 10.103 7.459 0 12.205-3.73 12.205-10.103m-.678 85.914V56.964c0-4.408-2.712-6.984-6.78-6.984H163.42v7.662h1.356c4.069 0 5.425 1.695 5.425 5.56v57.367M241.4 86.325v14.105c-4.068 4.068-8.814 6.374-12.883 6.374-4.068 0-6.103-1.967-6.103-7.256 0-5.831 1.357-8.069 6.103-9.9 3.39-1.424 6.781-2.305 12.884-3.323m-29.836-16.884 2.034-.814c5.425-2.17 8.815-2.983 12.884-3.73 2.034-.27 4.747-.542 6.103-.542 6.78 0 8.815 2.238 8.815 8.476v1.763c-9.493 1.56-12.206 2.103-17.63 3.255a54.533 54.533 0 0 0-8.138 2.713c-8.815 3.526-12.883 10.307-12.883 20.953 0 13.358 5.424 19.732 17.63 19.732 4.747 0 9.493-1.085 12.884-3.255 3.39-1.56 4.746-2.373 8.815-6.102v2.17c0 4.407 2.034 6.51 6.103 6.51h20.343v-7.256h-.678c-4.069 0-6.103-1.831-6.103-5.493v-34.65c0-18.038-6.103-24.14-23.734-24.14-6.102 0-11.527.677-16.952 1.966-5.425 1.288-8.137 2.238-14.24 5.425M300.395 120.57V72.695c4.747-4.408 8.137-6.103 12.884-6.103 4.746 0 6.103 2.034 6.103 9.222v44.754h21.02V72.425c0-9.9-1.356-14.173-4.068-17.902-3.39-3.662-7.46-5.357-13.562-5.357-8.137 0-14.24 2.984-23.733 11.189v-3.798c0-4.407-2.034-6.577-6.103-6.577h-20.343v7.662h.678c4.069 0 6.103 1.695 6.103 5.56v57.367"
          fillRule="evenodd"
        />
        <g
          transform="matrix(6.78093 0 0 -6.78093 -9880.484 5165.031)"
          clipPath="url(#AllianzIcon__a)"
          fillRule="evenodd"
        >
          <path
            d="M1516.9 745.91h-4.6l4.4 6.28v2.14h-6.6c-.8 0-1.1-.32-1.1-1.09v-1.89h1.1v.21c0 .57.3.8.9.8h2.4l-4.5-6.28v-2.16h8"
            fillRule="nonzero"
          />
          <path d="M1534.6 744.49v11.78c0 .95-.4 1.26-1.3 1.26h-2.7v-1.3h.3c.5 0 .7-.19.7-.77v-10.97h3zm1.6 0h2.9v8.89c0 .9-.4 1.26-1.3 1.26h-1.6v-10.15zm-6.2 0v10.15h-1.6c-.9 0-1.3-.36-1.3-1.26v-8.89h2.9zm12.5 5.92c0-5.51-4-9.53-9.4-9.53s-9.4 4.02-9.4 9.53 4 9.53 9.4 9.53 9.4-4.02 9.4-9.53m1.9 0c0 6.45-4.8 11.29-11.3 11.29-6.4 0-11.3-4.84-11.3-11.29 0-6.47 4.9-11.31 11.3-11.31 6.5 0 11.3 4.84 11.3 11.31" />
        </g>
      </g>
    </svg>
  );
};

const AllianzIcon = Icon;
export default AllianzIcon;
